import styled from 'styled-components';
import { Box } from '@landr/maestro';

const Anchor = styled(Box)`
    pointer-events: none;
`;

const AnchorAbsolute = styled(Anchor)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-width: 100% !important;
`;

const AnchorFixed = styled(Anchor)`
    position: fixed;
    width: 0;
    height: 0;
`;

export const Styled = {
    AnchorAbsolute,
    AnchorFixed,
};
